import { render, staticRenderFns } from "./IyDataLayout.vue?vue&type=template&id=2efa88e0&scoped=true&"
import script from "./IyDataLayout.vue?vue&type=script&lang=js&"
export * from "./IyDataLayout.vue?vue&type=script&lang=js&"
import style0 from "./IyDataLayout.vue?vue&type=style&index=0&id=2efa88e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa88e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efa88e0')) {
      api.createRecord('2efa88e0', component.options)
    } else {
      api.reload('2efa88e0', component.options)
    }
    module.hot.accept("./IyDataLayout.vue?vue&type=template&id=2efa88e0&scoped=true&", function () {
      api.rerender('2efa88e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/IyDataLayout.vue"
export default component.exports